(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './compose-multiplatform-core-compose-ui-ui.js', './compose-multiplatform-core-compose-ui-ui-graphics.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-icons-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-material-material-icons-core'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-icons-core'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-material-material-icons-core'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-icons-core'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-compose-material-material-icons-core'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-icons-core'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'compose-multiplatform-core-compose-material-material-icons-core'.");
    }
    globalThis['compose-multiplatform-core-compose-material-material-icons-core'] = factory(typeof globalThis['compose-multiplatform-core-compose-material-material-icons-core'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-material-material-icons-core'], globalThis['kotlin-kotlin-stdlib'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_compose_ui_ui, kotlin_org_jetbrains_compose_ui_ui_graphics) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var VOID = kotlin_kotlin.$_$.d;
  var Builder = kotlin_org_jetbrains_compose_ui_ui.$_$.b1;
  var get_DefaultFillType = kotlin_org_jetbrains_compose_ui_ui.$_$.w;
  var Companion_getInstance = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g4;
  var SolidColor = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q1;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.p4;
  var Companion_getInstance_1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q4;
  var PathBuilder = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.m;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  //endregion
  //region block: pre-declaration
  initMetadataForObject(Filled, 'Filled');
  initMetadataForObject(Filled_0, 'Filled');
  initMetadataForObject(AutoMirrored, 'AutoMirrored');
  initMetadataForObject(Icons, 'Icons');
  //endregion
  function Filled() {
  }
  var Filled_instance;
  function Filled_getInstance() {
    return Filled_instance;
  }
  function Filled_0() {
  }
  var Filled_instance_0;
  function Filled_getInstance_0() {
    return Filled_instance_0;
  }
  function AutoMirrored() {
    AutoMirrored_instance = this;
    this.cxv_1 = Filled_instance;
  }
  var AutoMirrored_instance;
  function AutoMirrored_getInstance() {
    if (AutoMirrored_instance == null)
      new AutoMirrored();
    return AutoMirrored_instance;
  }
  function Icons() {
    Icons_instance = this;
    this.dxv_1 = Filled_instance_0;
  }
  var Icons_instance;
  function Icons_getInstance() {
    if (Icons_instance == null)
      new Icons();
    return Icons_instance;
  }
  function get_MaterialIconDimension() {
    return MaterialIconDimension;
  }
  var MaterialIconDimension;
  var _arrowBack;
  function get_ArrowBack(_this__u8e3s4) {
    if (!(_arrowBack == null)) {
      return ensureNotNull(_arrowBack);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'AutoMirrored.Filled.ArrowBack';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, true);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(20.0, 11.0);
    $this$with.e6u(7.83);
    $this$with.d6u(5.59, -5.59);
    $this$with.k5s(12.0, 4.0);
    $this$with.d6u(-8.0, 8.0);
    $this$with.d6u(8.0, 8.0);
    $this$with.d6u(1.41, -1.41);
    $this$with.k5s(7.83, 13.0);
    $this$with.e6u(20.0);
    $this$with.h6u(-2.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _arrowBack = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_arrowBack);
  }
  var _arrowForward;
  var _exitToApp;
  function get_ExitToApp(_this__u8e3s4) {
    if (!(_exitToApp == null)) {
      return ensureNotNull(_exitToApp);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'AutoMirrored.Filled.ExitToApp';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, true);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(10.09, 15.59);
    $this$with.k5s(11.5, 17.0);
    $this$with.d6u(5.0, -5.0);
    $this$with.d6u(-5.0, -5.0);
    $this$with.d6u(-1.41, 1.41);
    $this$with.k5s(12.67, 11.0);
    $this$with.e6u(3.0);
    $this$with.h6u(2.0);
    $this$with.f6u(9.67);
    $this$with.d6u(-2.58, 2.59);
    $this$with.b6u();
    $this$with.i5s(19.0, 3.0);
    $this$with.e6u(5.0);
    $this$with.j6u(-1.11, 0.0, -2.0, 0.9, -2.0, 2.0);
    $this$with.h6u(4.0);
    $this$with.f6u(2.0);
    $this$with.g6u(5.0);
    $this$with.f6u(14.0);
    $this$with.h6u(14.0);
    $this$with.e6u(5.0);
    $this$with.h6u(-4.0);
    $this$with.e6u(3.0);
    $this$with.h6u(4.0);
    $this$with.j6u(0.0, 1.1, 0.89, 2.0, 2.0, 2.0);
    $this$with.f6u(14.0);
    $this$with.j6u(1.1, 0.0, 2.0, -0.9, 2.0, -2.0);
    $this$with.g6u(5.0);
    $this$with.j6u(0.0, -1.1, -0.9, -2.0, -2.0, -2.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _exitToApp = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_exitToApp);
  }
  var _keyboardArrowLeft;
  var _keyboardArrowRight;
  var _list;
  var _send;
  var _arrowBack_0;
  var _arrowForward_0;
  var _exitToApp_0;
  var _keyboardArrowLeft_0;
  var _keyboardArrowRight_0;
  var _list_0;
  var _send_0;
  var _arrowBack_1;
  var _arrowForward_1;
  var _exitToApp_1;
  var _keyboardArrowLeft_1;
  var _keyboardArrowRight_1;
  var _list_1;
  var _send_1;
  var _arrowBack_2;
  var _arrowForward_2;
  var _exitToApp_2;
  var _keyboardArrowLeft_2;
  var _keyboardArrowRight_2;
  var _list_2;
  var _send_2;
  var _arrowBack_3;
  var _arrowForward_3;
  var _exitToApp_3;
  var _keyboardArrowLeft_3;
  var _keyboardArrowRight_3;
  var _list_3;
  var _send_3;
  var _accountBox;
  var _accountCircle;
  function get_AccountCircle(_this__u8e3s4) {
    if (!(_accountCircle == null)) {
      return ensureNotNull(_accountCircle);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.AccountCircle';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(12.0, 2.0);
    $this$with.i6u(6.48, 2.0, 2.0, 6.48, 2.0, 12.0);
    $this$with.l6u(4.48, 10.0, 10.0, 10.0);
    $this$with.l6u(10.0, -4.48, 10.0, -10.0);
    $this$with.k6u(17.52, 2.0, 12.0, 2.0);
    $this$with.b6u();
    $this$with.i5s(12.0, 6.0);
    $this$with.j6u(1.93, 0.0, 3.5, 1.57, 3.5, 3.5);
    $this$with.k6u(13.93, 13.0, 12.0, 13.0);
    $this$with.l6u(-3.5, -1.57, -3.5, -3.5);
    $this$with.k6u(10.07, 6.0, 12.0, 6.0);
    $this$with.b6u();
    $this$with.i5s(12.0, 20.0);
    $this$with.j6u(-2.03, 0.0, -4.43, -0.82, -6.14, -2.88);
    $this$with.i6u(7.55, 15.8, 9.68, 15.0, 12.0, 15.0);
    $this$with.l6u(4.45, 0.8, 6.14, 2.12);
    $this$with.i6u(16.43, 19.18, 14.03, 20.0, 12.0, 20.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _accountCircle = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_accountCircle);
  }
  var _add;
  function get_Add(_this__u8e3s4) {
    if (!(_add == null)) {
      return ensureNotNull(_add);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Add';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(19.0, 13.0);
    $this$with.f6u(-6.0);
    $this$with.h6u(6.0);
    $this$with.f6u(-2.0);
    $this$with.h6u(-6.0);
    $this$with.e6u(5.0);
    $this$with.h6u(-2.0);
    $this$with.f6u(6.0);
    $this$with.g6u(5.0);
    $this$with.f6u(2.0);
    $this$with.h6u(6.0);
    $this$with.f6u(6.0);
    $this$with.h6u(2.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _add = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_add);
  }
  var _addCircle;
  var _arrowBack_4;
  var _arrowDropDown;
  var _arrowForward_4;
  var _build;
  var _call;
  var _check;
  function get_Check(_this__u8e3s4) {
    if (!(_check == null)) {
      return ensureNotNull(_check);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Check';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(9.0, 16.17);
    $this$with.k5s(4.83, 12.0);
    $this$with.d6u(-1.42, 1.41);
    $this$with.k5s(9.0, 19.0);
    $this$with.k5s(21.0, 7.0);
    $this$with.d6u(-1.41, -1.41);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _check = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_check);
  }
  var _checkCircle;
  function get_CheckCircle(_this__u8e3s4) {
    if (!(_checkCircle == null)) {
      return ensureNotNull(_checkCircle);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.CheckCircle';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(12.0, 2.0);
    $this$with.i6u(6.48, 2.0, 2.0, 6.48, 2.0, 12.0);
    $this$with.l6u(4.48, 10.0, 10.0, 10.0);
    $this$with.l6u(10.0, -4.48, 10.0, -10.0);
    $this$with.k6u(17.52, 2.0, 12.0, 2.0);
    $this$with.b6u();
    $this$with.i5s(10.0, 17.0);
    $this$with.d6u(-5.0, -5.0);
    $this$with.d6u(1.41, -1.41);
    $this$with.k5s(10.0, 14.17);
    $this$with.d6u(7.59, -7.59);
    $this$with.k5s(19.0, 8.0);
    $this$with.d6u(-9.0, 9.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _checkCircle = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_checkCircle);
  }
  var _clear;
  var _close;
  function get_Close(_this__u8e3s4) {
    if (!(_close == null)) {
      return ensureNotNull(_close);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Close';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(19.0, 6.41);
    $this$with.k5s(17.59, 5.0);
    $this$with.k5s(12.0, 10.59);
    $this$with.k5s(6.41, 5.0);
    $this$with.k5s(5.0, 6.41);
    $this$with.k5s(10.59, 12.0);
    $this$with.k5s(5.0, 17.59);
    $this$with.k5s(6.41, 19.0);
    $this$with.k5s(12.0, 13.41);
    $this$with.k5s(17.59, 19.0);
    $this$with.k5s(19.0, 17.59);
    $this$with.k5s(13.41, 12.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _close = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_close);
  }
  var _create;
  var _dateRange;
  var _delete;
  function get_Delete(_this__u8e3s4) {
    if (!(_delete == null)) {
      return ensureNotNull(_delete);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Delete';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(6.0, 19.0);
    $this$with.j6u(0.0, 1.1, 0.9, 2.0, 2.0, 2.0);
    $this$with.f6u(8.0);
    $this$with.j6u(1.1, 0.0, 2.0, -0.9, 2.0, -2.0);
    $this$with.g6u(7.0);
    $this$with.e6u(6.0);
    $this$with.h6u(12.0);
    $this$with.b6u();
    $this$with.i5s(19.0, 4.0);
    $this$with.f6u(-3.5);
    $this$with.d6u(-1.0, -1.0);
    $this$with.f6u(-5.0);
    $this$with.d6u(-1.0, 1.0);
    $this$with.e6u(5.0);
    $this$with.h6u(2.0);
    $this$with.f6u(14.0);
    $this$with.g6u(4.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _delete = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_delete);
  }
  var _done;
  var _edit;
  function get_Edit(_this__u8e3s4) {
    if (!(_edit == null)) {
      return ensureNotNull(_edit);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Edit';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(3.0, 17.25);
    $this$with.g6u(21.0);
    $this$with.f6u(3.75);
    $this$with.k5s(17.81, 9.94);
    $this$with.d6u(-3.75, -3.75);
    $this$with.k5s(3.0, 17.25);
    $this$with.b6u();
    $this$with.i5s(20.71, 7.04);
    $this$with.j6u(0.39, -0.39, 0.39, -1.02, 0.0, -1.41);
    $this$with.d6u(-2.34, -2.34);
    $this$with.j6u(-0.39, -0.39, -1.02, -0.39, -1.41, 0.0);
    $this$with.d6u(-1.83, 1.83);
    $this$with.d6u(3.75, 3.75);
    $this$with.d6u(1.83, -1.83);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _edit = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_edit);
  }
  var _email;
  function get_Email(_this__u8e3s4) {
    if (!(_email == null)) {
      return ensureNotNull(_email);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Email';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(20.0, 4.0);
    $this$with.k5s(4.0, 4.0);
    $this$with.j6u(-1.1, 0.0, -1.99, 0.9, -1.99, 2.0);
    $this$with.k5s(2.0, 18.0);
    $this$with.j6u(0.0, 1.1, 0.9, 2.0, 2.0, 2.0);
    $this$with.f6u(16.0);
    $this$with.j6u(1.1, 0.0, 2.0, -0.9, 2.0, -2.0);
    $this$with.k5s(22.0, 6.0);
    $this$with.j6u(0.0, -1.1, -0.9, -2.0, -2.0, -2.0);
    $this$with.b6u();
    $this$with.i5s(20.0, 8.0);
    $this$with.d6u(-8.0, 5.0);
    $this$with.d6u(-8.0, -5.0);
    $this$with.k5s(4.0, 6.0);
    $this$with.d6u(8.0, 5.0);
    $this$with.d6u(8.0, -5.0);
    $this$with.h6u(2.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _email = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_email);
  }
  var _exitToApp_4;
  var _face;
  var _favorite;
  function get_Favorite(_this__u8e3s4) {
    if (!(_favorite == null)) {
      return ensureNotNull(_favorite);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Favorite';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(12.0, 21.35);
    $this$with.d6u(-1.45, -1.32);
    $this$with.i6u(5.4, 15.36, 2.0, 12.28, 2.0, 8.5);
    $this$with.i6u(2.0, 5.42, 4.42, 3.0, 7.5, 3.0);
    $this$with.j6u(1.74, 0.0, 3.41, 0.81, 4.5, 2.09);
    $this$with.i6u(13.09, 3.81, 14.76, 3.0, 16.5, 3.0);
    $this$with.i6u(19.58, 3.0, 22.0, 5.42, 22.0, 8.5);
    $this$with.j6u(0.0, 3.78, -3.4, 6.86, -8.55, 11.54);
    $this$with.k5s(12.0, 21.35);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _favorite = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_favorite);
  }
  var _favoriteBorder;
  function get_FavoriteBorder(_this__u8e3s4) {
    if (!(_favoriteBorder == null)) {
      return ensureNotNull(_favoriteBorder);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.FavoriteBorder';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(16.5, 3.0);
    $this$with.j6u(-1.74, 0.0, -3.41, 0.81, -4.5, 2.09);
    $this$with.i6u(10.91, 3.81, 9.24, 3.0, 7.5, 3.0);
    $this$with.i6u(4.42, 3.0, 2.0, 5.42, 2.0, 8.5);
    $this$with.j6u(0.0, 3.78, 3.4, 6.86, 8.55, 11.54);
    $this$with.k5s(12.0, 21.35);
    $this$with.d6u(1.45, -1.32);
    $this$with.i6u(18.6, 15.36, 22.0, 12.28, 22.0, 8.5);
    $this$with.i6u(22.0, 5.42, 19.58, 3.0, 16.5, 3.0);
    $this$with.b6u();
    $this$with.i5s(12.1, 18.55);
    $this$with.d6u(-0.1, 0.1);
    $this$with.d6u(-0.1, -0.1);
    $this$with.i6u(7.14, 14.24, 4.0, 11.39, 4.0, 8.5);
    $this$with.i6u(4.0, 6.5, 5.5, 5.0, 7.5, 5.0);
    $this$with.j6u(1.54, 0.0, 3.04, 0.99, 3.57, 2.36);
    $this$with.f6u(1.87);
    $this$with.i6u(13.46, 5.99, 14.96, 5.0, 16.5, 5.0);
    $this$with.j6u(2.0, 0.0, 3.5, 1.5, 3.5, 3.5);
    $this$with.j6u(0.0, 2.89, -3.14, 5.74, -7.9, 10.05);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _favoriteBorder = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_favoriteBorder);
  }
  var _home;
  var _info;
  function get_Info(_this__u8e3s4) {
    if (!(_info == null)) {
      return ensureNotNull(_info);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Info';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(12.0, 2.0);
    $this$with.i6u(6.48, 2.0, 2.0, 6.48, 2.0, 12.0);
    $this$with.l6u(4.48, 10.0, 10.0, 10.0);
    $this$with.l6u(10.0, -4.48, 10.0, -10.0);
    $this$with.k6u(17.52, 2.0, 12.0, 2.0);
    $this$with.b6u();
    $this$with.i5s(13.0, 17.0);
    $this$with.f6u(-2.0);
    $this$with.h6u(-6.0);
    $this$with.f6u(2.0);
    $this$with.h6u(6.0);
    $this$with.b6u();
    $this$with.i5s(13.0, 9.0);
    $this$with.f6u(-2.0);
    $this$with.k5s(11.0, 7.0);
    $this$with.f6u(2.0);
    $this$with.h6u(2.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _info = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_info);
  }
  var _keyboardArrowDown;
  var _keyboardArrowLeft_4;
  var _keyboardArrowRight_4;
  var _keyboardArrowUp;
  var _list_4;
  var _locationOn;
  function get_LocationOn(_this__u8e3s4) {
    if (!(_locationOn == null)) {
      return ensureNotNull(_locationOn);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.LocationOn';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(12.0, 2.0);
    $this$with.i6u(8.13, 2.0, 5.0, 5.13, 5.0, 9.0);
    $this$with.j6u(0.0, 5.25, 7.0, 13.0, 7.0, 13.0);
    $this$with.l6u(7.0, -7.75, 7.0, -13.0);
    $this$with.j6u(0.0, -3.87, -3.13, -7.0, -7.0, -7.0);
    $this$with.b6u();
    $this$with.i5s(12.0, 11.5);
    $this$with.j6u(-1.38, 0.0, -2.5, -1.12, -2.5, -2.5);
    $this$with.l6u(1.12, -2.5, 2.5, -2.5);
    $this$with.l6u(2.5, 1.12, 2.5, 2.5);
    $this$with.l6u(-1.12, 2.5, -2.5, 2.5);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _locationOn = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_locationOn);
  }
  var _lock;
  function get_Lock(_this__u8e3s4) {
    if (!(_lock == null)) {
      return ensureNotNull(_lock);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Lock';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(18.0, 8.0);
    $this$with.f6u(-1.0);
    $this$with.k5s(17.0, 6.0);
    $this$with.j6u(0.0, -2.76, -2.24, -5.0, -5.0, -5.0);
    $this$with.k6u(7.0, 3.24, 7.0, 6.0);
    $this$with.h6u(2.0);
    $this$with.k5s(6.0, 8.0);
    $this$with.j6u(-1.1, 0.0, -2.0, 0.9, -2.0, 2.0);
    $this$with.h6u(10.0);
    $this$with.j6u(0.0, 1.1, 0.9, 2.0, 2.0, 2.0);
    $this$with.f6u(12.0);
    $this$with.j6u(1.1, 0.0, 2.0, -0.9, 2.0, -2.0);
    $this$with.k5s(20.0, 10.0);
    $this$with.j6u(0.0, -1.1, -0.9, -2.0, -2.0, -2.0);
    $this$with.b6u();
    $this$with.i5s(12.0, 17.0);
    $this$with.j6u(-1.1, 0.0, -2.0, -0.9, -2.0, -2.0);
    $this$with.l6u(0.9, -2.0, 2.0, -2.0);
    $this$with.l6u(2.0, 0.9, 2.0, 2.0);
    $this$with.l6u(-0.9, 2.0, -2.0, 2.0);
    $this$with.b6u();
    $this$with.i5s(15.1, 8.0);
    $this$with.k5s(8.9, 8.0);
    $this$with.k5s(8.9, 6.0);
    $this$with.j6u(0.0, -1.71, 1.39, -3.1, 3.1, -3.1);
    $this$with.j6u(1.71, 0.0, 3.1, 1.39, 3.1, 3.1);
    $this$with.h6u(2.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _lock = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_lock);
  }
  var _mailOutline;
  var _menu;
  var _moreVert;
  var _notifications;
  var _person;
  function get_Person(_this__u8e3s4) {
    if (!(_person == null)) {
      return ensureNotNull(_person);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Person';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(12.0, 12.0);
    $this$with.j6u(2.21, 0.0, 4.0, -1.79, 4.0, -4.0);
    $this$with.l6u(-1.79, -4.0, -4.0, -4.0);
    $this$with.l6u(-4.0, 1.79, -4.0, 4.0);
    $this$with.l6u(1.79, 4.0, 4.0, 4.0);
    $this$with.b6u();
    $this$with.i5s(12.0, 14.0);
    $this$with.j6u(-2.67, 0.0, -8.0, 1.34, -8.0, 4.0);
    $this$with.h6u(2.0);
    $this$with.f6u(16.0);
    $this$with.h6u(-2.0);
    $this$with.j6u(0.0, -2.66, -5.33, -4.0, -8.0, -4.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _person = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_person);
  }
  var _phone;
  function get_Phone(_this__u8e3s4) {
    if (!(_phone == null)) {
      return ensureNotNull(_phone);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Phone';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(6.62, 10.79);
    $this$with.j6u(1.44, 2.83, 3.76, 5.14, 6.59, 6.59);
    $this$with.d6u(2.2, -2.2);
    $this$with.j6u(0.27, -0.27, 0.67, -0.36, 1.02, -0.24);
    $this$with.j6u(1.12, 0.37, 2.33, 0.57, 3.57, 0.57);
    $this$with.j6u(0.55, 0.0, 1.0, 0.45, 1.0, 1.0);
    $this$with.g6u(20.0);
    $this$with.j6u(0.0, 0.55, -0.45, 1.0, -1.0, 1.0);
    $this$with.j6u(-9.39, 0.0, -17.0, -7.61, -17.0, -17.0);
    $this$with.j6u(0.0, -0.55, 0.45, -1.0, 1.0, -1.0);
    $this$with.f6u(3.5);
    $this$with.j6u(0.55, 0.0, 1.0, 0.45, 1.0, 1.0);
    $this$with.j6u(0.0, 1.25, 0.2, 2.45, 0.57, 3.57);
    $this$with.j6u(0.11, 0.35, 0.03, 0.74, -0.25, 1.02);
    $this$with.d6u(-2.2, 2.2);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _phone = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_phone);
  }
  var _place;
  var _playArrow;
  var _refresh;
  function get_Refresh(_this__u8e3s4) {
    if (!(_refresh == null)) {
      return ensureNotNull(_refresh);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Refresh';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(17.65, 6.35);
    $this$with.i6u(16.2, 4.9, 14.21, 4.0, 12.0, 4.0);
    $this$with.j6u(-4.42, 0.0, -7.99, 3.58, -7.99, 8.0);
    $this$with.l6u(3.57, 8.0, 7.99, 8.0);
    $this$with.j6u(3.73, 0.0, 6.84, -2.55, 7.73, -6.0);
    $this$with.f6u(-2.08);
    $this$with.j6u(-0.82, 2.33, -3.04, 4.0, -5.65, 4.0);
    $this$with.j6u(-3.31, 0.0, -6.0, -2.69, -6.0, -6.0);
    $this$with.l6u(2.69, -6.0, 6.0, -6.0);
    $this$with.j6u(1.66, 0.0, 3.14, 0.69, 4.22, 1.78);
    $this$with.k5s(13.0, 11.0);
    $this$with.f6u(7.0);
    $this$with.g6u(4.0);
    $this$with.d6u(-2.35, 2.35);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _refresh = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_refresh);
  }
  var _search;
  function get_Search(_this__u8e3s4) {
    if (!(_search == null)) {
      return ensureNotNull(_search);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Search';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(15.5, 14.0);
    $this$with.f6u(-0.79);
    $this$with.d6u(-0.28, -0.27);
    $this$with.i6u(15.41, 12.59, 16.0, 11.11, 16.0, 9.5);
    $this$with.i6u(16.0, 5.91, 13.09, 3.0, 9.5, 3.0);
    $this$with.k6u(3.0, 5.91, 3.0, 9.5);
    $this$with.k6u(5.91, 16.0, 9.5, 16.0);
    $this$with.j6u(1.61, 0.0, 3.09, -0.59, 4.23, -1.57);
    $this$with.d6u(0.27, 0.28);
    $this$with.h6u(0.79);
    $this$with.d6u(5.0, 4.99);
    $this$with.k5s(20.49, 19.0);
    $this$with.d6u(-4.99, -5.0);
    $this$with.b6u();
    $this$with.i5s(9.5, 14.0);
    $this$with.i6u(7.01, 14.0, 5.0, 11.99, 5.0, 9.5);
    $this$with.k6u(7.01, 5.0, 9.5, 5.0);
    $this$with.k6u(14.0, 7.01, 14.0, 9.5);
    $this$with.k6u(11.99, 14.0, 9.5, 14.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _search = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_search);
  }
  var _send_4;
  var _settings;
  var _share;
  function get_Share(_this__u8e3s4) {
    if (!(_share == null)) {
      return ensureNotNull(_share);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.Share';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(18.0, 16.08);
    $this$with.j6u(-0.76, 0.0, -1.44, 0.3, -1.96, 0.77);
    $this$with.k5s(8.91, 12.7);
    $this$with.j6u(0.05, -0.23, 0.09, -0.46, 0.09, -0.7);
    $this$with.l6u(-0.04, -0.47, -0.09, -0.7);
    $this$with.d6u(7.05, -4.11);
    $this$with.j6u(0.54, 0.5, 1.25, 0.81, 2.04, 0.81);
    $this$with.j6u(1.66, 0.0, 3.0, -1.34, 3.0, -3.0);
    $this$with.l6u(-1.34, -3.0, -3.0, -3.0);
    $this$with.l6u(-3.0, 1.34, -3.0, 3.0);
    $this$with.j6u(0.0, 0.24, 0.04, 0.47, 0.09, 0.7);
    $this$with.k5s(8.04, 9.81);
    $this$with.i6u(7.5, 9.31, 6.79, 9.0, 6.0, 9.0);
    $this$with.j6u(-1.66, 0.0, -3.0, 1.34, -3.0, 3.0);
    $this$with.l6u(1.34, 3.0, 3.0, 3.0);
    $this$with.j6u(0.79, 0.0, 1.5, -0.31, 2.04, -0.81);
    $this$with.d6u(7.12, 4.16);
    $this$with.j6u(-0.05, 0.21, -0.08, 0.43, -0.08, 0.65);
    $this$with.j6u(0.0, 1.61, 1.31, 2.92, 2.92, 2.92);
    $this$with.j6u(1.61, 0.0, 2.92, -1.31, 2.92, -2.92);
    $this$with.l6u(-1.31, -2.92, -2.92, -2.92);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _share = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_share);
  }
  var _shoppingCart;
  function get_ShoppingCart(_this__u8e3s4) {
    if (!(_shoppingCart == null)) {
      return ensureNotNull(_shoppingCart);
    }
    // Inline function 'androidx.compose.material.icons.materialIcon' call
    var name = 'Filled.ShoppingCart';
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = get_MaterialIconDimension();
    var tmp = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = get_MaterialIconDimension();
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(this_1);
    // Inline function 'androidx.compose.material.icons.materialPath' call
    var this_2 = new Builder(name, tmp, tmp$ret$2, get_MaterialIconDimension(), get_MaterialIconDimension(), VOID, VOID, false);
    var pathFillType = get_DefaultFillType();
    var tmp3 = new SolidColor(Companion_getInstance().i6b_1);
    var tmp13 = Companion_getInstance_0().s6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var strokeLineJoin = Companion_getInstance_1().y6j_1;
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(7.0, 18.0);
    $this$with.j6u(-1.1, 0.0, -1.99, 0.9, -1.99, 2.0);
    $this$with.k6u(5.9, 22.0, 7.0, 22.0);
    $this$with.l6u(2.0, -0.9, 2.0, -2.0);
    $this$with.l6u(-0.9, -2.0, -2.0, -2.0);
    $this$with.b6u();
    $this$with.i5s(1.0, 2.0);
    $this$with.h6u(2.0);
    $this$with.f6u(2.0);
    $this$with.d6u(3.6, 7.59);
    $this$with.d6u(-1.35, 2.45);
    $this$with.j6u(-0.16, 0.28, -0.25, 0.61, -0.25, 0.96);
    $this$with.j6u(0.0, 1.1, 0.9, 2.0, 2.0, 2.0);
    $this$with.f6u(12.0);
    $this$with.h6u(-2.0);
    $this$with.k5s(7.42, 15.0);
    $this$with.j6u(-0.14, 0.0, -0.25, -0.11, -0.25, -0.25);
    $this$with.d6u(0.03, -0.12);
    $this$with.d6u(0.9, -1.63);
    $this$with.f6u(7.45);
    $this$with.j6u(0.75, 0.0, 1.41, -0.41, 1.75, -1.03);
    $this$with.d6u(3.58, -6.49);
    $this$with.j6u(0.08, -0.14, 0.12, -0.31, 0.12, -0.48);
    $this$with.j6u(0.0, -0.55, -0.45, -1.0, -1.0, -1.0);
    $this$with.k5s(5.21, 4.0);
    $this$with.d6u(-0.94, -2.0);
    $this$with.k5s(1.0, 2.0);
    $this$with.b6u();
    $this$with.i5s(17.0, 18.0);
    $this$with.j6u(-1.1, 0.0, -1.99, 0.9, -1.99, 2.0);
    $this$with.l6u(0.89, 2.0, 1.99, 2.0);
    $this$with.l6u(2.0, -0.9, 2.0, -2.0);
    $this$with.l6u(-0.9, -2.0, -2.0, -2.0);
    $this$with.b6u();
    var tmp$ret$6 = $this$with.a6u();
    _shoppingCart = this_2.n9n(tmp$ret$6, pathFillType, '', tmp3, 1.0, null, 1.0, 1.0, tmp13, strokeLineJoin, 1.0).g3d();
    return ensureNotNull(_shoppingCart);
  }
  var _star;
  var _thumbUp;
  var _warning;
  var _accountBox_0;
  var _accountCircle_0;
  var _add_0;
  var _addCircle_0;
  var _arrowBack_5;
  var _arrowDropDown_0;
  var _arrowForward_5;
  var _build_0;
  var _call_0;
  var _check_0;
  var _checkCircle_0;
  var _clear_0;
  var _close_0;
  var _create_0;
  var _dateRange_0;
  var _delete_0;
  var _done_0;
  var _edit_0;
  var _email_0;
  var _exitToApp_5;
  var _face_0;
  var _favorite_0;
  var _favoriteBorder_0;
  var _home_0;
  var _info_0;
  var _keyboardArrowDown_0;
  var _keyboardArrowLeft_5;
  var _keyboardArrowRight_5;
  var _keyboardArrowUp_0;
  var _list_5;
  var _locationOn_0;
  var _lock_0;
  var _mailOutline_0;
  var _menu_0;
  var _moreVert_0;
  var _notifications_0;
  var _person_0;
  var _phone_0;
  var _place_0;
  var _playArrow_0;
  var _refresh_0;
  var _search_0;
  var _send_5;
  var _settings_0;
  var _share_0;
  var _shoppingCart_0;
  var _star_0;
  var _thumbUp_0;
  var _warning_0;
  var _accountBox_1;
  var _accountCircle_1;
  var _add_1;
  var _addCircle_1;
  var _arrowBack_6;
  var _arrowDropDown_1;
  var _arrowForward_6;
  var _build_1;
  var _call_1;
  var _check_1;
  var _checkCircle_1;
  var _clear_1;
  var _close_1;
  var _create_1;
  var _dateRange_1;
  var _delete_1;
  var _done_1;
  var _edit_1;
  var _email_1;
  var _exitToApp_6;
  var _face_1;
  var _favorite_1;
  var _favoriteBorder_1;
  var _home_1;
  var _info_1;
  var _keyboardArrowDown_1;
  var _keyboardArrowLeft_6;
  var _keyboardArrowRight_6;
  var _keyboardArrowUp_1;
  var _list_6;
  var _locationOn_1;
  var _lock_1;
  var _mailOutline_1;
  var _menu_1;
  var _moreVert_1;
  var _notifications_1;
  var _person_1;
  var _phone_1;
  var _place_1;
  var _playArrow_1;
  var _refresh_1;
  var _search_1;
  var _send_6;
  var _settings_1;
  var _share_1;
  var _shoppingCart_1;
  var _star_1;
  var _thumbUp_1;
  var _warning_1;
  var _accountBox_2;
  var _accountCircle_2;
  var _add_2;
  var _addCircle_2;
  var _arrowBack_7;
  var _arrowDropDown_2;
  var _arrowForward_7;
  var _build_2;
  var _call_2;
  var _check_2;
  var _checkCircle_2;
  var _clear_2;
  var _close_2;
  var _create_2;
  var _dateRange_2;
  var _delete_2;
  var _done_2;
  var _edit_2;
  var _email_2;
  var _exitToApp_7;
  var _face_2;
  var _favorite_2;
  var _favoriteBorder_2;
  var _home_2;
  var _info_2;
  var _keyboardArrowDown_2;
  var _keyboardArrowLeft_7;
  var _keyboardArrowRight_7;
  var _keyboardArrowUp_2;
  var _list_7;
  var _locationOn_2;
  var _lock_2;
  var _mailOutline_2;
  var _menu_2;
  var _moreVert_2;
  var _notifications_2;
  var _person_2;
  var _phone_2;
  var _place_2;
  var _playArrow_2;
  var _refresh_2;
  var _search_2;
  var _send_7;
  var _settings_2;
  var _share_2;
  var _shoppingCart_2;
  var _star_2;
  var _thumbUp_2;
  var _warning_2;
  var _accountBox_3;
  var _accountCircle_3;
  var _add_3;
  var _addCircle_3;
  var _arrowBack_8;
  var _arrowDropDown_3;
  var _arrowForward_8;
  var _build_3;
  var _call_3;
  var _check_3;
  var _checkCircle_3;
  var _clear_3;
  var _close_3;
  var _create_3;
  var _dateRange_3;
  var _delete_3;
  var _done_3;
  var _edit_3;
  var _email_3;
  var _exitToApp_8;
  var _face_3;
  var _favorite_3;
  var _favoriteBorder_3;
  var _home_3;
  var _info_3;
  var _keyboardArrowDown_3;
  var _keyboardArrowLeft_8;
  var _keyboardArrowRight_8;
  var _keyboardArrowUp_3;
  var _list_8;
  var _locationOn_3;
  var _lock_3;
  var _mailOutline_3;
  var _menu_3;
  var _moreVert_3;
  var _notifications_3;
  var _person_3;
  var _phone_3;
  var _place_3;
  var _playArrow_3;
  var _refresh_3;
  var _search_3;
  var _send_8;
  var _settings_3;
  var _share_3;
  var _shoppingCart_3;
  var _star_3;
  var _thumbUp_3;
  var _warning_3;
  //region block: init
  Filled_instance = new Filled();
  Filled_instance_0 = new Filled_0();
  MaterialIconDimension = 24.0;
  _arrowBack = null;
  _arrowForward = null;
  _exitToApp = null;
  _keyboardArrowLeft = null;
  _keyboardArrowRight = null;
  _list = null;
  _send = null;
  _arrowBack_0 = null;
  _arrowForward_0 = null;
  _exitToApp_0 = null;
  _keyboardArrowLeft_0 = null;
  _keyboardArrowRight_0 = null;
  _list_0 = null;
  _send_0 = null;
  _arrowBack_1 = null;
  _arrowForward_1 = null;
  _exitToApp_1 = null;
  _keyboardArrowLeft_1 = null;
  _keyboardArrowRight_1 = null;
  _list_1 = null;
  _send_1 = null;
  _arrowBack_2 = null;
  _arrowForward_2 = null;
  _exitToApp_2 = null;
  _keyboardArrowLeft_2 = null;
  _keyboardArrowRight_2 = null;
  _list_2 = null;
  _send_2 = null;
  _arrowBack_3 = null;
  _arrowForward_3 = null;
  _exitToApp_3 = null;
  _keyboardArrowLeft_3 = null;
  _keyboardArrowRight_3 = null;
  _list_3 = null;
  _send_3 = null;
  _accountBox = null;
  _accountCircle = null;
  _add = null;
  _addCircle = null;
  _arrowBack_4 = null;
  _arrowDropDown = null;
  _arrowForward_4 = null;
  _build = null;
  _call = null;
  _check = null;
  _checkCircle = null;
  _clear = null;
  _close = null;
  _create = null;
  _dateRange = null;
  _delete = null;
  _done = null;
  _edit = null;
  _email = null;
  _exitToApp_4 = null;
  _face = null;
  _favorite = null;
  _favoriteBorder = null;
  _home = null;
  _info = null;
  _keyboardArrowDown = null;
  _keyboardArrowLeft_4 = null;
  _keyboardArrowRight_4 = null;
  _keyboardArrowUp = null;
  _list_4 = null;
  _locationOn = null;
  _lock = null;
  _mailOutline = null;
  _menu = null;
  _moreVert = null;
  _notifications = null;
  _person = null;
  _phone = null;
  _place = null;
  _playArrow = null;
  _refresh = null;
  _search = null;
  _send_4 = null;
  _settings = null;
  _share = null;
  _shoppingCart = null;
  _star = null;
  _thumbUp = null;
  _warning = null;
  _accountBox_0 = null;
  _accountCircle_0 = null;
  _add_0 = null;
  _addCircle_0 = null;
  _arrowBack_5 = null;
  _arrowDropDown_0 = null;
  _arrowForward_5 = null;
  _build_0 = null;
  _call_0 = null;
  _check_0 = null;
  _checkCircle_0 = null;
  _clear_0 = null;
  _close_0 = null;
  _create_0 = null;
  _dateRange_0 = null;
  _delete_0 = null;
  _done_0 = null;
  _edit_0 = null;
  _email_0 = null;
  _exitToApp_5 = null;
  _face_0 = null;
  _favorite_0 = null;
  _favoriteBorder_0 = null;
  _home_0 = null;
  _info_0 = null;
  _keyboardArrowDown_0 = null;
  _keyboardArrowLeft_5 = null;
  _keyboardArrowRight_5 = null;
  _keyboardArrowUp_0 = null;
  _list_5 = null;
  _locationOn_0 = null;
  _lock_0 = null;
  _mailOutline_0 = null;
  _menu_0 = null;
  _moreVert_0 = null;
  _notifications_0 = null;
  _person_0 = null;
  _phone_0 = null;
  _place_0 = null;
  _playArrow_0 = null;
  _refresh_0 = null;
  _search_0 = null;
  _send_5 = null;
  _settings_0 = null;
  _share_0 = null;
  _shoppingCart_0 = null;
  _star_0 = null;
  _thumbUp_0 = null;
  _warning_0 = null;
  _accountBox_1 = null;
  _accountCircle_1 = null;
  _add_1 = null;
  _addCircle_1 = null;
  _arrowBack_6 = null;
  _arrowDropDown_1 = null;
  _arrowForward_6 = null;
  _build_1 = null;
  _call_1 = null;
  _check_1 = null;
  _checkCircle_1 = null;
  _clear_1 = null;
  _close_1 = null;
  _create_1 = null;
  _dateRange_1 = null;
  _delete_1 = null;
  _done_1 = null;
  _edit_1 = null;
  _email_1 = null;
  _exitToApp_6 = null;
  _face_1 = null;
  _favorite_1 = null;
  _favoriteBorder_1 = null;
  _home_1 = null;
  _info_1 = null;
  _keyboardArrowDown_1 = null;
  _keyboardArrowLeft_6 = null;
  _keyboardArrowRight_6 = null;
  _keyboardArrowUp_1 = null;
  _list_6 = null;
  _locationOn_1 = null;
  _lock_1 = null;
  _mailOutline_1 = null;
  _menu_1 = null;
  _moreVert_1 = null;
  _notifications_1 = null;
  _person_1 = null;
  _phone_1 = null;
  _place_1 = null;
  _playArrow_1 = null;
  _refresh_1 = null;
  _search_1 = null;
  _send_6 = null;
  _settings_1 = null;
  _share_1 = null;
  _shoppingCart_1 = null;
  _star_1 = null;
  _thumbUp_1 = null;
  _warning_1 = null;
  _accountBox_2 = null;
  _accountCircle_2 = null;
  _add_2 = null;
  _addCircle_2 = null;
  _arrowBack_7 = null;
  _arrowDropDown_2 = null;
  _arrowForward_7 = null;
  _build_2 = null;
  _call_2 = null;
  _check_2 = null;
  _checkCircle_2 = null;
  _clear_2 = null;
  _close_2 = null;
  _create_2 = null;
  _dateRange_2 = null;
  _delete_2 = null;
  _done_2 = null;
  _edit_2 = null;
  _email_2 = null;
  _exitToApp_7 = null;
  _face_2 = null;
  _favorite_2 = null;
  _favoriteBorder_2 = null;
  _home_2 = null;
  _info_2 = null;
  _keyboardArrowDown_2 = null;
  _keyboardArrowLeft_7 = null;
  _keyboardArrowRight_7 = null;
  _keyboardArrowUp_2 = null;
  _list_7 = null;
  _locationOn_2 = null;
  _lock_2 = null;
  _mailOutline_2 = null;
  _menu_2 = null;
  _moreVert_2 = null;
  _notifications_2 = null;
  _person_2 = null;
  _phone_2 = null;
  _place_2 = null;
  _playArrow_2 = null;
  _refresh_2 = null;
  _search_2 = null;
  _send_7 = null;
  _settings_2 = null;
  _share_2 = null;
  _shoppingCart_2 = null;
  _star_2 = null;
  _thumbUp_2 = null;
  _warning_2 = null;
  _accountBox_3 = null;
  _accountCircle_3 = null;
  _add_3 = null;
  _addCircle_3 = null;
  _arrowBack_8 = null;
  _arrowDropDown_3 = null;
  _arrowForward_8 = null;
  _build_3 = null;
  _call_3 = null;
  _check_3 = null;
  _checkCircle_3 = null;
  _clear_3 = null;
  _close_3 = null;
  _create_3 = null;
  _dateRange_3 = null;
  _delete_3 = null;
  _done_3 = null;
  _edit_3 = null;
  _email_3 = null;
  _exitToApp_8 = null;
  _face_3 = null;
  _favorite_3 = null;
  _favoriteBorder_3 = null;
  _home_3 = null;
  _info_3 = null;
  _keyboardArrowDown_3 = null;
  _keyboardArrowLeft_8 = null;
  _keyboardArrowRight_8 = null;
  _keyboardArrowUp_3 = null;
  _list_8 = null;
  _locationOn_3 = null;
  _lock_3 = null;
  _mailOutline_3 = null;
  _menu_3 = null;
  _moreVert_3 = null;
  _notifications_3 = null;
  _person_3 = null;
  _phone_3 = null;
  _place_3 = null;
  _playArrow_3 = null;
  _refresh_3 = null;
  _search_3 = null;
  _send_8 = null;
  _settings_3 = null;
  _share_3 = null;
  _shoppingCart_3 = null;
  _star_3 = null;
  _thumbUp_3 = null;
  _warning_3 = null;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = get_ArrowBack;
  _.$_$.b = get_ExitToApp;
  _.$_$.c = get_AccountCircle;
  _.$_$.d = get_Add;
  _.$_$.e = get_Check;
  _.$_$.f = get_CheckCircle;
  _.$_$.g = get_Close;
  _.$_$.h = get_Delete;
  _.$_$.i = get_Edit;
  _.$_$.j = get_Email;
  _.$_$.k = get_Favorite;
  _.$_$.l = get_FavoriteBorder;
  _.$_$.m = get_Info;
  _.$_$.n = get_LocationOn;
  _.$_$.o = get_Lock;
  _.$_$.p = get_Person;
  _.$_$.q = get_Phone;
  _.$_$.r = get_Refresh;
  _.$_$.s = get_Search;
  _.$_$.t = get_Share;
  _.$_$.u = get_ShoppingCart;
  _.$_$.v = get_MaterialIconDimension;
  _.$_$.w = Filled_instance;
  _.$_$.x = AutoMirrored_getInstance;
  _.$_$.y = Filled_instance_0;
  _.$_$.z = Icons_getInstance;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-material-material-icons-core.js.map
